import { Fragment } from "react";
import './index.scss'
import { FiChevronRight } from "react-icons/fi";
import { CustomLink } from "custom";
import { slugify } from "utils";

interface Props {
    cat_sub_cat: {
        name: string,
        sub_cat: string[],
        img: string,
    }[]
}

export function FeaturedCategories(props: Props) {

    return (
        <div className="bg-grey">
            <div className="max-width p-x mob-py-07 featuredCategories">
                <div className="featuredCategories-head">
                    <div className="featuredCategories-head__title">
                        featured categories
                    </div>
                    <p className="featuredCategories-head__body">Choose your necessary products from this feature categories.</p>
                </div>
                <div className="featuredCategories-list">
                    {props.cat_sub_cat.map(i => (
                        <div key={i.name} className="featuredCategories-list-item">
                            <CustomLink name="category" cat_name={slugify(i.name)} className="featuredCategories-list-item_top">
                                <Fragment>
                                    {i.name}
                                </Fragment>
                            </CustomLink>

                            <div className="featuredCategories-list-item_bottom">
                                <img src={i.img} alt="" className="featuredCategories-list-item_bottom_logo" />

                                <div className="featuredCategories-list-item_bottom_right">
                                    {i.sub_cat.map(sub => (
                                        <CustomLink key={sub} name="sub-category" cat_name={slugify(i.name)} sub_cat_name={slugify(sub)} >
                                            <Fragment>
                                                <FiChevronRight />{sub}
                                            </Fragment>
                                        </CustomLink>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div >
    )
}